import type { SupportedCountry } from './types';

/** ArchiPro Pinterest profile URL for each market. */
export const PINTEREST_PROFILE_URLS: Record<SupportedCountry, string> = {
    NZ: 'https://www.pinterest.com/ArchiPro/',
    AU: 'https://www.pinterest.com/ArchiPro_AU/',
    US: 'https://www.pinterest.com/ArchiPro_US/',
};
